module.exports = __webpack_public_path__ + "media/images/patent/x_13-2c5a72e70218e20445b09fd914c5f77c.png";